module.exports = __webpack_public_path__ + "img/color-white.71d3930e.svg";